import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function MyListings() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const load = async () => {
    try {
      const r = await api.get('/users/my-listings');
      setListings(r.data.listings || []);
    } catch {
      toast.error('Failed to load your listings');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const cancelListing = async (id) => {
    if (!window.confirm('Cancel this listing and return remaining credits?')) return;

    setBusyId(id);
    try {
      await api.delete(`/listings/${id}`);
      toast.success('Listing cancelled');
      await load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Cancel failed');
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div style={{ maxWidth: '1300px', margin: '0 auto', padding: '3rem 2.5rem' }}>
      <div className="section-tag">Manage</div>
      <h1 className="section-title">MY <span style={{ color: 'var(--neon-cyan)' }}>LISTINGS</span></h1>

      <div className="card" style={{ marginTop: '1.5rem' }}>
        {loading ? (
          <div style={{ color: 'var(--muted)', fontFamily: 'Space Mono, monospace', fontSize: '0.75rem' }}>Loading...</div>
        ) : (
          <table className="data-table">
            <thead>
              <tr><th>Title</th><th>Type</th><th>Price</th><th>Available</th><th>Status</th><th>Created</th><th>Action</th></tr>
            </thead>
            <tbody>
              {listings.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: 'center', color: 'var(--muted)', padding: '2rem' }}>
                    No listings found. <Link to="/trade" style={{ color: 'var(--neon-green)', textDecoration: 'none' }}>Create one from Trade Desk →</Link>
                  </td>
                </tr>
              ) : listings.map((l) => (
                <tr key={l.id}>
                  <td>{l.title}</td>
                  <td style={{ color: 'var(--muted)' }}>{l.credit_type}</td>
                  <td>₹{l.price_per_unit?.toLocaleString('en-IN')}</td>
                  <td>{l.qty_available?.toLocaleString()}</td>
                  <td><span className={`badge badge-${l.status === 'active' ? 'green' : l.status === 'sold' ? 'cyan' : 'muted'}`}>{l.status}</span></td>
                  <td style={{ color: 'var(--muted)' }}>{new Date(l.created_at).toLocaleDateString('en-IN')}</td>
                  <td>
                    {l.status === 'active' && l.qty_available > 0 ? (
                      <button
                        onClick={() => cancelListing(l.id)}
                        disabled={busyId === l.id}
                        style={{
                          padding: '0.3rem 0.8rem',
                          border: '1px solid var(--neon-pink)',
                          color: 'var(--neon-pink)',
                          background: 'transparent',
                          fontFamily: 'Space Mono, monospace',
                          fontSize: '0.65rem',
                          cursor: 'pointer',
                        }}
                      >
                        {busyId === l.id ? 'CANCELLING...' : 'CANCEL'}
                      </button>
                    ) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
